export default "__VITE_ASSET__8dc335c4__"